module.exports = __webpack_public_path__ + "img/icon-delete.f000c3b9.svg";